import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) return;
    if (localStorage.getItem("bme_pwa_dismissed") === "1") return;

    const onPrompt = (e) => {
      e.preventDefault();
      setPrompt(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", () => setVisible(false));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    await prompt.userChoice;
    setPrompt(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem("bme_pwa_dismissed", "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed z-[60] left-3 right-3 bottom-20 md:left-auto md:right-6 md:bottom-6 md:w-80"
    >
      <div className="glass border border-stone-200 rounded-2xl shadow-xl p-4 flex items-center gap-3">
        <div className="h-11 w-11 rounded-xl bg-primary grid place-items-center text-white shrink-0">
          <Download className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display font-bold text-sm leading-tight">Install Book My Event</p>
          <p className="text-xs text-muted-foreground">Add the app to your home screen for quick access.</p>
        </div>
        <button
          data-testid="pwa-install-btn"
          onClick={install}
          className="shrink-0 h-9 px-4 bg-primary text-white rounded-full text-sm font-bold hover:bg-primary/90 transition-colors"
        >
          Install
        </button>
        <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="shrink-0 text-muted-foreground">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
